// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // Your Button styles here
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px 16px'
        },
      },
    },
  },
});

export default theme;